// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"H2-z","displaySixCardTiles":"I2-z"};